// Auswahl einer Mengeneinheit — gruppiert, übersetzt, mit eigener Eingabe.
//
// Die Liste deckt die üblichen Fälle ab. Wer etwas anderes braucht („Bund",
// „Kiste"), wählt „Andere Einheit" und tippt sie ein. Gespeichert wird immer
// der deutsche Name, weil er so auf der Rechnung steht.
import { useState } from 'react';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { EINHEITEN, GRUPPEN, einheitFinden } from '../lib/einheiten';

const ANDERE = '__andere';

export default function EinheitWahl({ wert, beiAenderung, label, kompakt = false }: {
  wert: string;
  beiAenderung: (einheit: string) => void;
  label?: string;
  /** Ohne Beschriftung und schmal — für Tabellenzeilen. */
  kompakt?: boolean;
}) {
  const { t } = useSprache();
  const bekannt = !!einheitFinden(wert) || !wert;
  const [freitext, setFreitext] = useState(!bekannt);

  const auswahl = (
    <select
      value={freitext ? ANDERE : (einheitFinden(wert)?.name ?? 'Stück')}
      onChange={e => {
        if (e.target.value === ANDERE) { setFreitext(true); beiAenderung(''); }
        else { setFreitext(false); beiAenderung(e.target.value); }
      }}
      // Auch ohne sichtbare Beschriftung (ab der zweiten Positionszeile) braucht
      // das Feld einen Namen — sonst ist es für Bildschirmleser stumm.
      aria-label={label || t('feld.einheit')}
      className="w-full rounded-lg border border-slate-300 bg-white px-2 py-2 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
    >
      {GRUPPEN.map(g => (
        <optgroup key={g.schluessel} label={t(g.schluessel)}>
          {EINHEITEN.filter(e => g.groesse.includes(e.groesse)).map(e => (
            <option key={e.code} value={e.name}>
              {/* Bei übersetzten Wörtern das deutsche Original dahinter — so steht
                  es auf der gedruckten Rechnung, und man sieht es vorher. */}
              {e.schluessel ? (t(e.schluessel) === e.name ? e.name : `${t(e.schluessel)} (${e.name})`) : e.name}
            </option>
          ))}
        </optgroup>
      ))}
      <option value={ANDERE}>{t('einheit.andere')}</option>
    </select>
  );

  return (
    <label className="block">
      {!kompakt && label !== '' && (
        <span className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">{label ?? t('feld.einheit')}</span>
      )}
      {auswahl}
      {freitext && (
        <input
          value={wert}
          onChange={e => beiAenderung(e.target.value.slice(0, 20))}
          placeholder={t('einheit.eigenePlatzhalter')}
          aria-label={t('einheit.eigene')}
          autoFocus
          className="mt-1 w-full rounded-lg border border-slate-300 bg-white px-2 py-2 text-sm text-slate-900 placeholder:text-slate-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
        />
      )}
    </label>
  );
}
